import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage';
import iccbanner from "../../../assets/CampuLifeImages/iccbanner.jpeg"
import iccactivity1 from "../../../assets/CampuLifeImages/iccactivity1.jpg"
import iccactivity2 from "../../../assets/CampuLifeImages/iccactivity2.jpg"
import iccactivity3 from "../../../assets/CampuLifeImages/iccactivity3.jpg"
import iccactivity4 from "../../../assets/CampuLifeImages/iccactivity4.jpg"



const InternalCompliance = () => {
      
  const womenCellContent = {
    name:"iic",
    pagename:"Internal complaints Committee",
    title:"Internal Complaints Committee Activities",
    viewmore:"true",
    viewless:"true",
    hover:true,
    contentImg:iccbanner,
    para:"This committee has been formed at Central University of TamilNadu, to address issues under THE SEXUAL HARASSMENT OF WOMEN AT WORKPLACE (PREVENTION, PROHIBITION AND REDRESSAL) ACT, 2013. The purpose of this committee is to provide protection against sexual harassment of women at workplace and for the prevention and redressal of complaints and for matters connected therewith.Hence, the right of all women working or visiting any workplace whether in the capacity of regular, temporary, adhoc, or daily wages basis is protected under the Act. The employee who had a right to a workplace free of sexual harassment, had complained about it.",
    paranext:'The Act recognizes the right of every woman to a safe and secure workplace environment irrespective of her age or work status.',
    paraone:"According to the Court, had the organisation compliedwith the Vishaka Guidelines and set up such a Complaints Committee, the preventative benefitwould have been three-fold:",
    points:["Ensured a place where women employees could seek redress;","Sent a clear message to the workplace that such complaints would be enquired into by aspecially designated committee with external expertise;","Prevented a series of litigation that followed."],
    handbook1:"Ministry of Women and Child Development - (Prevention, Prohibition and Redressal) Act and Rule 2013",
    handbook2:"Ministry of Law and Justice - (Prevention, Prohibition and Redressal) Act and Rule 2013",
    fourhover:true
  }
  const hoverContent = [
    {img:iccactivity1 , para1:"",para2:""},
    {img:iccactivity2 , para1:"",para2:""},
    {img:iccactivity3 , para1:"",para2:""},
    {img:iccactivity4 , para1:"",para2:""}
  ]

  const tableData = [
            {title:"Internal Compliants Committee Member"},
            {headings:[{heading1:"S.No.",heading2:"Name",heading3:"Designation & Department",heading4:"Position",heading5:"Contact Number"}]},
            {data:[{ id: 1, name: 'Dr. R. RajaLakshmi', designDept:"Asst. Prof. & Head, Department of Computer Science" ,pos:"President",emailId:"9600802980"},
            { id: 2, name: 'Dr. S. Padmdevi', designDept:"Assistant Professor" ,pos:"Member",emailId:"9443585511" },
            { id: 3, name: 'Mrs. K. Viji', designDept:"Office Assistant" ,pos:"Member",emailId:"8973732820" },
            { id: 4, name: 'Ms. M. J. Mahalakshmi', designDept:"Student" ,pos:"Member",emailId:"9176835758" },
            { id: 5, name: 'Ms. Akshya Harini', designDept:"Student" ,pos:"Member",emailId:"9361785140" },
            { id: 6, name: 'Dr. Mini Priya', designDept:"Women Entrepreneur" ,pos:"Member",emailId:"9629104364" }]},
            {padding:true}
          ];


           
          
  return (
   <>
      <ExtenStudClubGrievPage data={womenCellContent} hoverContent={hoverContent} tableData={tableData}/>
   </>
  )
}

export default InternalCompliance